import { Fragment } from 'react'

import ReviewStar from '@/components/Review/ReviewStar'
import '@/components/Review/ReviewStars/ReviewStars.scss'

export default function ReviewStars({ scale = 24, reviewRating = 5 }: { scale?: number; reviewRating?: number }) {
  const integerPart = Math.floor(reviewRating)
  const decimalPart = reviewRating - integerPart

  return (
    <div className="c-review-reviewStars">
      {new Array(6).fill(null).map((_, index) => {
        return (
          <Fragment key={index}>
            {index === 0 ? (
              <></>
            ) : (
              <ReviewStar
                percentage={integerPart >= index ? 100 : integerPart + 1 == index ? decimalPart * 100 : 0}
                scale={scale}
              />
            )}
          </Fragment>
        )
      })}
    </div>
  )
}
